<template>
  <div class="yunxiao teacher new-wallet" data-test="new-wallet">
    <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0061.png" alt="background-image">
    <div class="features-nav">
      <div>
        <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0063.png" alt="feature 2">
      </div>
      <div>
        <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0062.png" alt="feature 1">
      </div>
    </div>
    <div class="to-open-btn" @click="showOpenConfirmDialog" >
      <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0064.png" alt="background-image">
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      pageTitle: '收费管家',
      // 是否有商户号
      sfgjInfo: {},
      items: [
        {
          iconName: '',
          name: '对账 ',
          slogan: '毫无压力',
          details: '订单信息与支付信息一一对应，明细汇总清晰明了',
        },
        {
          iconName: '',
          name: '收款 ',
          slogan: '方式多样',
          details: '支持微信、支付宝，线上线下收款轻松搞定',
        },
      ],
    }
  },
  computed: {
    ...Vuex.mapState(["userInfo", "companyInfo"]),
  },
  created () {
    this.queryCompanyMerchant();
  },
  methods: {
    async getSfgjInfo () {
      const before = Date.now();
      this.$api.fundsGetSfgjInfo()
        .then(res=> {
          if (res.code === 200) {
            this.$toast.clear();
            this.sfgjInfo = res.data;
            if (res.data && res.data.hasMch) {
              this.$router.push('/walletSuccess');               
              return false;
            }
            if (!app.teacher.user.superAdmin) {            
              return false;
            }
            // 可能是从中台收费管家页面返回的
            if (app.ls.get("wallet-to-b.xiaogj")) {
              app.ls.set("wallet-to-b.xiaogj", false);
              return false;
            }
            if (res.data && res.data.isOpenSfgj && res.data.sfgjUrl) {
              app.ls.set("wallet-to-b.xiaogj", true);  
              setTimeout(() => {
                window.location.href = res.data.sfgjUrl;
              }, 300 - (Date.now()  - before));
              return false;
            }
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{
          if (!err || !err.code) {
            console.log(err);    
            this.$toast.fail(err.msg || '网络异常，请稍后重试');
          }
        });
    },
    async queryCompanyMerchant () {
      this.showLoading();
      this.getSfgjInfo();
    },
    showOpenConfirmDialog () {
      if (!app.teacher.user.superAdmin) {
        this.$dialog
          .confirm({
            title: '无开通权限',
            cancelButtonColor: 'var(--c1)',
            showConfirmButton: false,
            message: '开通收费管家涉及机构财务管理，请联系机构超级管理员开通',
            cancelButtonText: '我知道了',
          })
          .catch(res => {
            // if (res === 'cancel')
          });
        return false;
      }
      let { sfgjInfo } = this;
      if (sfgjInfo.isOpenSfgj && sfgjInfo.sfgjUrl) {
        app.ls.set("wallet-to-b.xiaogj", true);      
        window.location.href = sfgjInfo.sfgjUrl;
        return false;
      }
      this.showLoading();
      this.$api.fundsOpenSfgj()
        .then(res => {
          this.$toast.clear();
          if (res && res.code === 200) {
            this.$toast.success('操作成功');
            if (res.data.sfgjUrl) {
              app.ls.set("wallet-to-b.xiaogj", true);  
              window.location.href = res.data.sfgjUrl;
            }
            return false;
          }
          if (res && res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch ( () => {
          console.log('开通收费管家出错了')
        });         
    }
  }
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.new-wallet{
  position: relative;
  height: 100%;
  flex-direction: column;
  color: var(--g6);
  background: linear-gradient(180deg, #2F58ED 0%, #5199FB 100%);
  img{
    pointer-events: none;
  }
  >img{
    position: relative;
    display: block;
    width: 100%;
    min-height: calc(var(--w) * 320);
    margin: 0;
  }
  .features-nav{
    display: flex;
    position: relative;
    margin: calc(var(--w) * -80) 0 0;
    padding: 0 calc(var(--gap) * 16);
    width: 100%;
    min-height: calc(var(--w) * 182);
    overflow: hidden;
    >div{
      flex: 1;
      &:last-child{
        margin-left: calc(var(--gap) * 12);
      }
      >img{
        width: 100%;
      }
    }
  }
  .to-open-btn{
    margin: calc(var(--gap) * 32) auto 0;
    width: 90%;
    cursor: pointer;
    >img{
      width: 100%;
    }
  }

}
</style>